import { ItemTypes } from './Map';
import { useDrag, useDrop } from 'react-dnd';
import './sample.css';
import { stringToColour, hashString, ColorLuminance, deterministicallyRearrange, improvedHash } from '../Reusable/Color';

const Sample = ({
  sample,
  sampleActions,
  selectedSampleActions,
  colorMapActions,
}) => {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemTypes.WELL,
      item: sample,
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [sample]
  );

  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: ItemTypes.PRIMER,
      drop: (item, monitor) => {
        const primer = monitor.getItem().primer;
        if (primer.number || primer.order === sample.order) {
          sampleActions.assignPrimer(sample._id, monitor.getItem().primer._id)
        }
      },
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    [sample]
  );

  const handleClick = (event) => {
    if (event.ctrlKey || event.metaKey) {
      selectedSampleActions.handleSelect(sample._id);
    }
  };

  const getBackgroundColor = () => {
    if (sample.type === 'control') {
      return 'red';
    } else if (sample.primer) {
      console.log(sample)
      console.log(sample.primer.substr(-10))
      return ColorLuminance(stringToColour((deterministicallyRearrange(sample.primer))), 0.5);
    } else {
      return null;
    }
  };

  return (
    <div
      ref={drag}
      className={
        selectedSampleActions.getSelectedSamples().has(sample._id)
          ? 'dashed-border'
          : null
      }
      style={{
        boxSizing: 'border-box',
        width: '100%',
        height: '100%',
        opacity: isDragging ? 0.5 : 1,
        backgroundColor: getBackgroundColor(),
        padding: '8px',
      }}
      onClick={handleClick}
    >
      <div
        ref={sample.type === 'sanger' ? drop : null}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
        }}
      >
        <p style={{ fontSize: '14px', textAlign: 'center', marginBottom: '0' }}>
          {sample.name}
        </p>
      </div>
    </div>
  );
};

export default Sample;
